import { Dialog } from "vant";
var vm = this;

function onBridgeReady(data) {
  console.log('调用微信支付WeixinJSBridge'); // console.log('参数',data)

  WeixinJSBridge.invoke('getBrandWCPayRequest', {
    // 下面参数内容都是后台返回的
    'appId': data.appId,
    // 公众号名称，由商户传入
    'timeStamp': data.timeStamp,
    // 时间戳
    'nonceStr': data.nonceStr,
    // 随机串
    'package': data.package,
    // 预支付id
    'signType': data.signType,
    // 微信签名方式
    'paySign': data.paySign // 微信签名

  }, function (res) {
    // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
    if (res.err_msg === 'get_brand_wcpay_request:ok') {
      Dialog.alert({
        message: '支付成功'
      }).then(function () {
        //支付成功后更新订单状态
        vm.$router.push('/orders');
      });
    } else {
      Dialog.alert({
        message: '支付失败'
      }).then(function () {
        vm.$router.push('/orders');
      });
    }
  });
}

export default (function (data) {
  // 下面是解决WeixinJSBridge is not defined 报错的方法
  if (typeof WeixinJSBridge === 'undefined') {
    // 微信浏览器内置对象。参考微信官方文档
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', vm.onBridgeReady(data), false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', vm.onBridgeReady(data));
      document.attachEvent('onWeixinJSBridgeReady', vm.onBridgeReady(data));
    }
  } else {
    console.log('准备调用微信支付');
    vm.onBridgeReady(data);
  }
});